import {TIEMPOACTIVACIONCONTRATO} from "../../Constantes";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {crearHash} from "../Funciones/crearHash";
import {adap_nuevo_contrato_mov} from "../Adaptadores/adap_nuevo_contrato_mov";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";

export const crearContrato = async ({entidad, usuario}) => {

    //Crear el contrato
    entidad.fecha = new Date().getTime()
    entidad.fechaInicio = new Date().getTime() + TIEMPOACTIVACIONCONTRATO
    entidad.idUsuario = usuario.id
    entidad.codigoUsuario = usuario.codigo
    entidad.correo = usuario.correo
    entidad.nombre = usuario.nombre

    let consecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'contratos'})
    entidad.consecutivo = consecutivo.data

    entidad.hashString = JSON.stringify(entidad)
    entidad.hash = crearHash({text: entidad.hashString})

    entidad.estado = 'Activo'

    let dox = await guardarDoc('contratos', entidad)
    if (dox.res) {
        await aumentarConsecutivo({col: 'consecutivos', id: 'contratos', actual: entidad.consecutivo})
        let consecutivoMov = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
        entidad.consecutivo = consecutivoMov.data

        let des = await registrarMovimiento({movimiento: adap_nuevo_contrato_mov(entidad), estado: 'Aceptado'})
        if (des) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: entidad.consecutivo})
            return {res: true, data: entidad, hash: entidad.hash}
        } else {
            return {res: false, data: 'Algo inesperado paso, comunicate con soporte con este codigo: 02MOV'}
        }

    } else {
        return {res: false, data: 'Algo inesperado paso, comunicate con soporte con este codigo: 01CON'}

    }


}